import React from "react";
import "./About.css";
import NavBar from "../NavBar/Navbar";
import AboutImg from "../../Assets/AboutImg1.jpeg";
import AboutImg2 from "../../Assets/AboutImg2.jpeg";
import AboutImg3 from "../../Assets/AboutImg3.jpeg";
import MainFooter from "../MainFooter";
function About() {
  return (
    <div>
      <NavBar ContactNumber={+917990201423} />
      <div className="aboutContainer">
        <h1 className="AboutHeading">About Us</h1>
        <div className="contentContainer">
          <div className="AboutContent">
            <p data-aos="fade-right">
              Keeping Your Windscreens Crystal Clear At Vishal Glasses, we
              specialize in repairing and replacing windshields for a wide range
              of vehicles, including cars, trucks, dumpers, and even trains. We
              understand how important a clear and functioning windshield is for
              safe driving, and we're dedicated to providing our customers with
              top-quality service at competitive prices.
            </p>

            <img src={AboutImg} alt="" data-aos="fade-right" />
          </div>

          <div className="AboutContent">
            <img src={AboutImg2} alt="" data-aos="fade-right" />
            <p data-aos="fade-right">
              <h3>We're Here to Help!</h3>
              Whether you have a small chip in your car windshield or need a
              complete replacement for your train, our team has the expertise
              and resources to handle the job. We're committed to providing
              exceptional customer service and ensuring your complete
              satisfaction.
            </p>
          </div>

          <div className="AboutContent">
            <p data-aos="fade-right">
              <h2>Why Choose Us</h2>
              <ul>
                <li>Windshield replacement in under 2 hours</li>
                <li>Doorstep facility</li>
                <li>Conveniently located service centres</li>
                <li>Experienced technicians</li>
                <li>Commitment to quality</li>
                <li>Genuine products used</li>
                <li>
                  Safe and environment-friendly disposal of waste, including
                  damaged glass
                </li>
              </ul>
            </p>

            <img src={AboutImg3} alt="" data-aos="fade-right" />
          </div>
        </div>
      </div>
      <div className="AboutFooter">
        <p>
          Contact Us Today! Have a question or need a quote? Don't hesitate to
          contact us! We're open Monday to Saturday from 9:00 AM to 8:00 PM, and
          you can always message or call us anytime for your convenience
        </p>
      </div>

      <MainFooter/> 


    </div>
  );
}

export default About;
